/**
 * @prettier
 */

import _values from 'lodash/values';
import { createSelector } from 'reselect';
import { getPricing } from '../reducers/pricing/selectors';
import { getCardType, getActiveSelection } from '../reducers/pdp/selectors';
import { getLeadVariationOptionValues } from './cardProjectSelector';
import { getSearchFilters } from './cardCatalogSelector';

export const getBasePrice = createSelector(getCardType, getPricing, (cardType, pricing) => {
  if (!pricing[cardType]) {
    return null;
  }

  const prices = _values(pricing[cardType]).map(type => type.basePrice);

  return Math.min(...prices);
});

export const getPDPCardIsLetterpress = createSelector(
  getActiveSelection,
  selection => selection['printing-type'] === 'letterpress'
);

export const getCustomizingCardIsLetterpress = createSelector(
  getLeadVariationOptionValues,
  optionValues => optionValues['printing-type'] === 'letterpress'
);

export const getLetterpressFilter = createSelector(
  getSearchFilters,
  filters => filters.is_letterpress
);
